// extracted by mini-css-extract-plugin
export default {"content":"ClinicScriptPatientDetails_content__aeniV","centerFilters":"ClinicScriptPatientDetails_centerFilters__CFtyl"};